import { useEffect, useRef } from 'react';

import Page from '../../components/Page/index.ts';
import StaticPageLayout from '../../components/StaticPageLayout/index.ts';
import { LANG } from '../../services/Config.js';

import data from './data.json';

const htmlString = `
  <script id="CookieDeclaration" src="https://consent.cookiebot.com/ad589a4e-20a9-413c-970b-6657d68559de/cd.js" type="text/javascript" async></script>
`;

const Cookies = () => {
  const divRef = useRef<HTMLDivElement>(null);
  const { appStrings } = LANG;

  useEffect(() => {
    const fragment = document.createRange().createContextualFragment(htmlString);
    divRef.current?.append(fragment);
  }, []);

  return (
    <Page title={appStrings.PAGES.COOKIES}>
      <StaticPageLayout breadcrumbsItems={data.breadcrumbs}>
        <h2 className="typography-v1-legacy-h2 text-v1-background-200">
          Oversikt over cookies i bruk på scoopr.no
        </h2>
        <br />
        <div ref={divRef} />
      </StaticPageLayout>
    </Page>
  );
};

export default Cookies;
